import styled from "styled-components";

export const MuteBtn = styled.button`
  background-color: transparent;
  border-style: none;

  & img {
    cursor: pointer;
    height: 20px;
    margin-right: 95vw;
    margin-top: 3vh;
  }
`;
